import Vue from 'vue'
import App from './App.vue'
import router from './router'
// ant design vue
import './plugin'

import './router/permission'

// vuex
import store from './store'

// 全局引入按需引入UI库 vant
import '@/plugin/vant'
// 移动端适配
import 'lib-flexible'

//引入swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import '../node_modules/swiper/swiper.min.css'
// Vue.use(VueAwesomeSwiper)

// 拦截器
import './api/axios.interceptors';

import waterfall from "vue-waterfall2";
Vue.use(waterfall);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
